import { Configuration, FixturesApi} from "../_api";
import {lazySingleton} from "../_common/common";

// singleton
export default lazySingleton<FixturesApi>(()=>new FixturesApi(new Configuration({basePath: window.env.JOBS_API_basePath})));
